const INIT_STATE = {
   avatars: []
};

export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_AVATARS": {
         return { ...state, avatars: action.payload };
      }
      default:
         return state;
   }
};
